import React, { useState, useEffect } from "react";
import Modal from "../../../components/elements/Modal";
import "../css/VersioningComponent.css";

const VersioningComponent = ({ isOpen, onClose, version }) => {
  const [latestRelease, setLatestRelease] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadReleaseNotes = async () => {
      try {
        const response = await fetch("/releaseNotes.txt");

        const text = await response.text();
        const data = JSON.parse(text);

        if (!data || !data.version || !data.date || !data.notes) {
          throw new Error("Invalid release notes format");
        }

        setLatestRelease(data);
        setError(null);
      } catch (error) {
        setLatestRelease({ version: version || "N/A", date: "N/A", notes: [] });
      }
    };

    loadReleaseNotes();
  }, [version]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="version-modal-container">
        <div className="version-modal-header">
          <h2 className="version-modal-title">Version Info</h2>
        </div>

        <div className="version-info-item">
          <span className="version-info-label">Version:</span>
          {version || latestRelease?.version}
        </div>
        <div className="version-info-item">
          <span className="version-info-label">Release Date:</span>
          {latestRelease?.date}
        </div>

        <div className="version-changes-title">Changes:</div>
        <ul className="version-changes-list">
          {latestRelease?.notes?.map((note, idx) => (
            <li key={idx} className="version-changes-item">
              {note}
            </li>
          ))}
        </ul>

        <div className="version-modal-footer">
          <button onClick={onClose} className="version-modal-ok-button">
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default VersioningComponent;
